import React from 'react';
import { Box, Stack } from '@mui/material';
import { AccountBalanceOutlined } from '@mui/icons-material';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { CurrencyInputField, InputField } from 'components/form/rhf';

import { DealBuilderFormValues } from '../../../../types';
import { PayoffGoodThroughDateCell } from './PayoffGoodThroughDateCell';

interface Props {
  rowIndex: number;
  form: UseFormReturn<DealBuilderFormValues>;
  onFieldBlur: (rowIndex: number) => void;
}

export const TradeInPayoffDetails = ({ rowIndex, form, onFieldBlur }: Props) => {
  const amountOwed = useWatch({ control: form.control, name: `pricing.tradeIn.${rowIndex}.amountOwed` });

  if (!amountOwed) return null;

  return (
    <Stack direction="row" gap="1rem" alignItems="flex-start">
      <AccountBalanceOutlined color="action" sx={{ mt: '0.5rem' }} />

      <Box width="200px">
        <InputField
          label="Lienholder"
          control={form.control}
          name={`pricing.tradeIn.${rowIndex}.payoffLienholder`}
          inputProps={{
            size: 'small',
            variant: 'outlined',
            onBlur: () => onFieldBlur(rowIndex),
          }}
        />
      </Box>

      <Box width="200px">
        <InputField
          label="Lienholder Account #"
          control={form.control}
          name={`pricing.tradeIn.${rowIndex}.payoffAccountNumber`}
          inputProps={{
            size: 'small',
            variant: 'outlined',
            onBlur: () => onFieldBlur(rowIndex),
          }}
        />
      </Box>

      <Box width="250px">
        <PayoffGoodThroughDateCell control={form.control} rowIndex={rowIndex} onFieldBlur={onFieldBlur} />
      </Box>

      <Box width="150px">
        <CurrencyInputField
          label="Payoff Amount"
          control={form.control}
          name={`pricing.tradeIn.${rowIndex}.amountOwed`}
          textFieldProps={{
            size: 'small',
            variant: 'outlined',
            onBlur: () => onFieldBlur(rowIndex),
            helperText: 'Edit in Amount Owed',
            disabled: true,
          }}
        />
      </Box>
    </Stack>
  );
};
